import { render, staticRenderFns } from "./transactionWithdrawView.vue?vue&type=template&id=11962596"
import script from "./transactionWithdrawView.vue?vue&type=script&lang=js"
export * from "./transactionWithdrawView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports